import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 53021908-1FB5-4293-896E-94C5330E6101
 * name oci
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/oci.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const OciIcon = createSvgIcon(<><path d="M2 2V22H22V2M19.12 19.03H4.87V5H19.13V19.03M14.83 10.71H17.69V17.59H14.83M14.83 6.41H17.69V9.27H14.83M6.3 6.41V17.59H13.4V14.72H9.17V9.28H13.4V6.41Z" /></>, 'OciIcon');
export default OciIcon